
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1.14v.05l6.61 4.36a.35.35 0 01.1.46.22.22 0 01-.09.1h-.05l-.18.08v6.36a.89.89 0 01.61 1.14l-.09.2-.72 1.11-.71-1.13a.88.88 0 01.23-1.19.68.68 0 01.24-.12V6.45l-1.7.79V5.69a.79.79 0 00-.33-.64h-.07a9.36 9.36 0 00-4.45-1A9.36 9.36 0 004 5a.76.76 0 00-.4.6v1.64l-2.41-1.1a.31.31 0 01-.11-.09.36.36 0 01.05-.43l6.63-4.43A1.2 1.2 0 019 1.14zm-.6 4.11a9.27 9.27 0 013.72.82.26.26 0 01.15.24v1.71h.23a.75.75 0 01.73.77v1A1.75 1.75 0 0112 11.5q-.81 3.12-3.56 3.12c-1.83 0-3-1-3.58-3.12a1.76 1.76 0 01-1.31-1.72v-1A.75.75 0 014.28 8h.19V6.31a.27.27 0 01.15-.24 9.69 9.69 0 013.78-.82zm0 2a5.84 5.84 0 00-2.59.4.09.09 0 000 .09V9H4.52v.84a1 1 0 001 1h.27a2.71 2.71 0 002.7 2.73A2.72 2.72 0 0011 10.88v-.07h.26a1 1 0 001-1V9h-1.21V7.75a.09.09 0 00-.05-.09 5.84 5.84 0 00-2.59-.4z"}})])
          )
        }
      }
    